import { p as parseCookies } from "../cookies-04bd2321.js";
import { g as getTealiumIds } from "../getTealiumIds-c24d3498.js";
import { getMerkleIds } from "../browser/plugins/merkle/getMerkleIds.es.js";
import { getVisitId } from "../browser/plugins/visitId/visitId.es.js";
import "./logger.es.js";
import "../waitFor-1b67bbb8.js";
import "../cookieHandler-ac6954c1.js";
import "../browser/plugins/visitId/adapter.es.js";
import "../browser/plugins/timeOnPage/timeOnPage.es.js";
import "../v4-88c20f3b.js";
import "../browser/plugins/visitId/constants.es.js";
import "../browser/plugins/visitId/processUrlVisitId.es.js";
import "../browser/plugins/visitId/utils.es.js";
let currentUserInsightIds = null;
const fetchIds = async () => {
  const cookies = parseCookies();
  const previousVisitId = cookies["eh_previous_visit_id"];
  const visitId = getVisitId();
  const { tealium_visitor_id } = await getTealiumIds();
  const merkleData = await getMerkleIds();
  return { visit_id: visitId, previous_visit_id: previousVisitId, tealium_visitor_id, ...merkleData };
};
const setUserInsightIds = (insightData) => {
  currentUserInsightIds = insightData;
};
const getUserInsightIds = () => currentUserInsightIds;
export {
  fetchIds,
  getUserInsightIds,
  setUserInsightIds
};
